import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuoteCodeService {

  constructor(private httpClientService: HttpClientService) { }

  async getByIdQuoteCodes(transactionId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.QuoteCode,
      queryString: `transactionId=${transactionId}`
    });
    return await firstValueFrom(observable);
  }

  async updateQuoteCode(transactionManagementId, email) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.QuoteCode
    }, 
    {
      transactionManagementId:transactionManagementId,
      email:email
    });
    return await firstValueFrom(observable);
  }

  async quoteCode(mail,customerId){
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.QuoteCode
    },
    {
      mail:mail,
      customerId:customerId
    });
    return await firstValueFrom(observable);
  }

  async quoteCodeConfirmed(code,customerId){
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.QuoteCode,
      action:"CustomerDetailConfirmed"
    },
    {
      code:code,
      customerId:customerId
    });
    return await firstValueFrom(observable);
  }
}
